<template>
    <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
        style="overflow: hidden;">
        <div class="m-portlet m-portlet--mobile">
            <SearchTitle label='轮转表管理' url='/cycle/plan/stulist'></SearchTitle>
            <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
                <!--begin: Search Form -->
                <div class="m-form m-form--label-align-right">
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">管理单元：</label>
                            </div>
                            <div class="m-form__control">
                                <el-select v-model="condition.secretarysec" filterable placeholder="全部"
                                    @change="ManageSecChange">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in managesecOptions" :key="item.DictItemID"
                                        :label="item.DictItemName" :value="item.DictItemID">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">轮转科室：</label>
                            </div>
                            <div class="m-form__control">
                                <el-select v-model="condition.section" filterable placeholder="全部">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in secOptions" :key="item.DictItemID"
                                        :label="item.DictItemName" :value="item.DictItemID">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <SearchNormalText v-model='condition.truename' label='姓名' v-show="condition.viewtype == 1">
                    </SearchNormalText>
                    <ZPGLSearchDictItemSelect v-model='condition.stuyear' label='届别'
                        :dictid='this.$utils.DictEnum.stuyear' v-show="condition.viewtype == 1">
                    </ZPGLSearchDictItemSelect>
                    <SearchNormalText v-model='condition.cardno' label='工号' v-show="condition.viewtype == 1">
                    </SearchNormalText>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">轮转开始时间：</label>
                            </div>
                            <div class="m-form__control">
                                <el-date-picker v-model="condition.cpbegindate" type="month" placeholder="轮转时间"
                                    value-format="yyyy-MM">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">轮转结束时间：</label>
                            </div>
                            <div class="m-form__control">
                                <el-date-picker v-model="condition.cpenddate" type="month" placeholder="轮转时间"
                                    value-format="yyyy-MM">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">视图类型：</label>
                            </div>
                            <div class="m-form__control" style="height: 40px;line-height: 40px;">
                                <el-radio-group v-model="condition.viewtype">
                                    <el-radio label="1">学员视图</el-radio>
                                    <el-radio label="2">科室视图</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>
                </div>
                <div style="clear: both;"></div>
                <div class="m--margin-top-10 m--margin-bottom-10"
                    style="width: 100%;text-align: center;float: initial;">
                    <el-button type="primary" icon="el-icon-search" @click="Search(1)">查询</el-button>
                    <ImportButton url="/cycle/plan/import" buttonname="导入" v-if="this.IsSec == false"></ImportButton>
                    <ExportButton :url='exportUrl' buttonname="导出" v-if="this.IsSec == false"></ExportButton>
                    <!-- <el-button type="primary" icon="el-icon-search" @click="UpdateCyclePlanDetail">数据调整</el-button> -->
                    <!-- <el-button type="primary" icon="el-icon-search" @click="SynCyclePlanDetail">数据同步</el-button> -->
                </div>
                <!--end: Search Form -->
                <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
                    <!--begin: Datatable -->
                    <el-table :data="cpData" style="width: 100%" v-if="condition.viewtype == 1" size="medium">
                        <el-table-column fixed label="姓名" width="100" v-if="this.IsSec == false">
                            <template slot-scope="scope">
                                <span @click="Info(scope.row.StuID,scope.row.StuName)"
                                    style="cursor: pointer;">{{scope.row.StuName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column fixed prop="StuName" label="姓名" width="100" v-if="this.IsSec == true">
                        </el-table-column>
                        <el-table-column fixed prop="StuNo" label="工号" width="80">
                        </el-table-column>
                        <el-table-column fixed prop="SectionName" label="当前科室" width="180">
                        </el-table-column>
                        <el-table-column fixed prop="StuYearName" label="届别" width="80">
                        </el-table-column>
                        <el-table-column width="150" v-for="col in cols" :label="col.label" v-bind:key="col.prop">
                            <template slot-scope="scope">
                                <div v-html="formatCPInfo(scope.row[col.prop])"></div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-table :data="cpSectionData" style="width: 100%" v-if="condition.viewtype == 2" size="medium">
                        <el-table-column fixed label="科室" width="150">
                            <template slot-scope="scope">
                                {{scope.row.CPSecName}}
                            </template>
                        </el-table-column>
                        <el-table-column width="160" v-for="col in cols" :label="col.label" v-bind:key="col.prop">
                            <template slot-scope="scope">
                                <div v-html="formatCPSectionInfo(scope.row[col.prop])"></div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--end: Datatable -->
                    <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="condition.currentPage" :page-sizes="[2, 10, 20, 30, 40]"
                            :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
                            :total="condition.recordCount">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PlanStuList',
        data () {
            return {
                condition: {
                    username: '',
                    rolelevel: '',
                    truename: '',
                    section: '',
                    cardno: '',
                    token: '',
                    pageSize: 10,
                    currentPage: 1,
                    recordCount: 0,
                    viewtype: '1',
                    stuyear: '',
                    cpbegindate: '',
                    cpenddate: '',
                    secretarysec: ''
                },
                secOptions: [],
                managesecOptions: [],
                tableData: '',
                exportUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/StuListOut',
                cols: [],
                cpData: [],
                cpSectionData: [],
                IsSec: false
            }
        },
        created () {
            window.Info = this.Info
        },
        methods: {
            formatCPInfo: function (val) {
                var info = ''
                if (val != null) {
                    var cpinfos = val.split(',')
                    for (var i = 0; i < cpinfos.length; i++) {
                        var cpinfo = cpinfos[i].split('|')
                        if (cpinfo[1] == "1") {
                            info += '<span>' + cpinfo[0] + '</span>,'
                        } else if (cpinfo[1] == "2") {
                            info += '<span style=\'color:green;\'>' + cpinfo[0] + '</span>,'
                        } else if (cpinfo[1] == "3") {
                            info += '<span style=\'color:red;\'>' + cpinfo[0] + '</span>,'
                        } else {
                            info += '<span>' + cpinfo[0] + '</span>,'
                        }
                    }
                    info = info.substring(0, info.length - 1)
                }
                return info
            },
            formatCPSectionInfo: function (val) {
                var info = ''
                if (val != null) {
                    var stuinfos = val.split(',')
                    for (var i = 0; i < stuinfos.length; i++) {
                        if ((i + 1) % 3 == 0) {
                            if (i == 0) {
                                info += stuinfos[i] + ','
                            } else {
                                if (i == stuinfos.length - 1) {
                                    info += stuinfos[i] + ','
                                } else {
                                    info += stuinfos[i] + '<br>'
                                }
                            }
                        } else {
                            info += stuinfos[i] + ','
                        }
                    }
                    info = info.substring(0, info.length - 1)
                }
                return info
            },
            // 调整每页显示数
            handleCurrentChange: function (val) {
                this.condition.currentPage = val
                this.Search()
            },
            // 分页操作
            handleSizeChange: function (val) {
                this.condition.pageSize = val
                this.condition.currentPage = 1
                this.Search()
            },
            Search: function (pageindex) {
                if (this.condition.cpbegindate == "" || this.condition.cpbegindate == null) {
                    this.$message({
                        message: '轮转开始时间不能为空',
                        type: 'warning'
                    })
                    return
                }

                if (this.condition.cpenddate == "" || this.condition.cpenddate == null) {
                    this.$message({
                        message: '轮转结束时间不能为空',
                        type: 'warning'
                    })
                    return
                }


                this.GetMonthRange(this.condition.cpbegindate, this.condition.cpenddate)
                if (pageindex != null) {
                    this.condition.currentPage = pageindex
                }
                this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/StuList', this.condition)
                    .then(res => {
                        if (res.data.Code === 0) {
                            if (this.condition.viewtype == 1) {
                                this.cpData = res.data.Data
                            } else {
                                this.cpSectionData = res.data.Data
                            }
                            this.condition.recordCount = res.data.Pager.RecordCount
                        } else {
                            this.$message({
                                message: res.data.Msg + '，' + res.data.Error,
                                type: 'error'
                            })
                        }
                    })
                    .catch(err => {
                        this.tableData = ''
                        this.condition.recordCount = 0
                        console.log(err)
                        this.$message({
                            message: '查询失败',
                            type: 'error'
                        })
                    })
            },
            Info: function (id, name) {
                this.$router.push({
                    name: 'PlanList',
                    params: {
                        id: id,
                        name: name
                    }
                })
            },
            GetMonthRange: function (startdate, enddate) {
                this.cols = []
                var start = startdate.split("-")
                var end = enddate.split("-")
                var min = new Date()
                var max = new Date()
                min.setFullYear(start[0], start[1] * 1 - 1, 1)
                max.setFullYear(end[0], end[1] * 1 - 1, 1)
                var curr = min
                while (curr <= max) {
                    var month = curr.getMonth() + 1
                    var strMonth = ''
                    if (month < 10) {
                        strMonth = '0' + month
                    } else {
                        strMonth = month
                    }
                    var strProp = curr.getFullYear() + '' + strMonth
                    var strLabel = curr.getFullYear() + "-" + strMonth
                    var arg = {
                        prop: strProp,
                        label: strLabel
                    }
                    this.cols.push(arg)
                    curr.setMonth(month)
                }
            },
            UpdateCyclePlanDetail: function () {
                this.loading = true
                var args = {
                    pageSize: 999,
                    currentPage: 1,
                }
                this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/UpdateCyclePlanDetail', args)
                    .then(res => {
                        if (res.data.Code === 0) {
                            this.$message({
                                message: '数据调整成功',
                                type: 'success'
                            })
                        } else {
                            this.$message({
                                message: res.data.Msg + '，' + res.data.Error,
                                type: 'error'
                            })
                        }
                        this.loading = false
                    })
                    .catch(err => {
                        console.log(err)
                        this.$message({
                            message: '数据调整失败',
                            type: 'error'
                        })
                        this.loading = false
                    })
            },
            SynCyclePlanDetail: function () {
                this.loading = true
                var args = {
                    pageSize: 999,
                    currentPage: 1,
                }
                this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/SynCyclePlanDetail', args)
                    .then(res => {
                        if (res.data.Code === 0) {
                            this.$message({
                                message: '数据同步成功',
                                type: 'success'
                            })
                        } else {
                            this.$message({
                                message: res.data.Msg + '，' + res.data.Error,
                                type: 'error'
                            })
                        }
                        this.loading = false
                    })
                    .catch(err => {
                        console.log(err)
                        this.$message({
                            message: '数据调整失败',
                            type: 'error'
                        })
                        this.loading = false
                    })
            },
            LoadManageSec: function () {
                var args = {
                    token: this.condition.token,
                    username: this.condition.username,
                    rolelevel: this.condition.rolelevel
                }
                var that = this
                this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function (data) {
                    that.managesecOptions = data.Data
                }, null, null, null)
            },
            ManageSecChange: function () {
                this.condition.section = ''
                this.secOptions = []
                this.LoadCPSec()
            },
            LoadCPSec: function () {
                var args = {
                    token: this.condition.token,
                    username: this.condition.username,
                    rolelevel: this.condition.rolelevel,
                    mamagesec: this.condition.secretarysec
                }
                var that = this
                this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function (data) {
                    that.secOptions = data.Data
                }, null, null, null)
            }
        },
        mounted: function () {
            this.condition.token = sessionStorage.getItem('token')
            this.condition.username = sessionStorage.getItem('username')
            this.condition.rolelevel = sessionStorage.getItem('rolelevel')
            if (this.condition.rolelevel == 2) {
                this.IsSec = true
                // this.$router.push('/main/cycle/plan/seclist')
            }
            var date = new Date()
            var year = date.getFullYear()
            this.condition.cpbegindate = year + '-01'
            this.condition.cpenddate = year + '-12'
            this.LoadManageSec()
            this.LoadCPSec()
            this.Search()
        }
    }
</script>

<style scoped="scoped">
    /deep/.el-table .cell {
        line-height: 25px;
    }

    /deep/.el-input {
        width: 220px;
    }

    /deep/.el-table__header-wrapper {
        width: 100%;
    }
</style>